import React from "react";
import { Box } from "@mui/material";

/** Red asterisk shown after required field labels across signup steps. */
export default function ReqMark() {
  return (
    <Box component="span" sx={{ color: "error.main", ml: 0.25 }} aria-hidden>
      *
    </Box>
  );
}
